import { UserRolesIds } from '@models';
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { type UserState } from './auth.reducers';

export const selectAuthState = createFeatureSelector<UserState>('auth');

export const selectUser = createSelector(selectAuthState, auth => auth);

export const isLoggedIn = createSelector(selectAuthState, auth => !!auth.id);

export const isBasicUser = createSelector(
  selectAuthState,
  auth => auth.role.id as UserRolesIds === UserRolesIds.ReadOnly,
);
export const isSuperAdmin = createSelector(selectAuthState, auth => auth.role.id as UserRolesIds === UserRolesIds.SuperAdmin);
export const userRole = createSelector(selectAuthState, auth => auth.role.id as UserRolesIds);

export const isLoading = createSelector(selectAuthState, userState => userState.isLoading);
